module.exports = __webpack_public_path__ + "static/media/SharePaymentIcon.9cd6696d.svg";